import { render, staticRenderFns } from "./chart-block.vue?vue&type=template&id=176bd780&scoped=true"
import script from "./chart-block.vue?vue&type=script&lang=ts"
export * from "./chart-block.vue?vue&type=script&lang=ts"
import style0 from "./chart-block.vue?vue&type=style&index=0&id=176bd780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bd780",
  null
  
)

export default component.exports